import React, { useEffect, useState, useRef } from "react";
import {
  GetPurchaseVoucherList,
  GetPurchaseVoucherById,
  UpdatePurchaseVoucher,
  CreatePurchaseVoucher,
  DeletePurchaseVoucher,
  getAllTransporter,
  GetApprovedPOs as fetchpos,
  ApprovePurchaseVoucher,
  GetNextPvNo,
} from "../../../Services/Services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Modal,
  Box,
  TextField,
  MenuItem,
  Popover,
  Typography,
  Checkbox,
  Autocomplete,
  Grid,
  Chip,
  useMediaQuery,     // ✅ Add
  useTheme,          // ✅ Add
  Collapse,          // ✅ Add
  Divider,           // ✅ Add
  Menu
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";  // ⭐ ADD
import {
  Edit,
  Delete,
  Print,
  Visibility,
  Add,
  Close,
  ExpandMore,    // ✅ Add
  ExpandLess,    // ✅ Add
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePurchasePdf } from "../Accounts/PurchaseVoucherPrint";
import config from "../../../config";
import { CircularProgress } from "@mui/material";
const PurchaseVouchers = () => {
  // ===== States =====
  // ⭐ DATE RANGE STATES (statusFilter ke baad add karo)
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateRangeFilter, setDateRangeFilter] = useState("today");
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });
  const dateInputRef = useRef(null);
  const [statusFilter, setStatusFilter] = useState("");
  const [purchaseVouchers, setPurchaseVouchers] = useState([]);
  const [purchaseLists, setPurchaseLists] = useState([]);
  const [transporterLists, setTransporterLists] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [rowErrors, setRowErrors] = useState([]);
  const [rows, setRows] = useState([blankRow()]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [open, setOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewData, setViewData] = useState({});
  const [loading, setLoading] = useState(false); // 🔹 loader state
  const [anchorEl, setAnchorEl] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [PurchaseToApprove, setPurchaseToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [expandedPurchase, setExpandedPurchase] = useState(null);
  const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
  const [filters, setFilters] = useState({
    purchase_no: "",
    po_no: "",
    supplier: "",
    status: "Pending",
  });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // ✅ new states for inline custom picker
const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
const [tempCustomDateRange, setTempCustomDateRange] = useState({ from: "", to: "" });

// ✅ Apply Custom Date Range
const handleApplyCustomDateRange = () => {
  if (tempCustomDateRange.from && tempCustomDateRange.to) {
    setCustomDateRange({ ...tempCustomDateRange });
    setDateRangeFilter("custom");
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
  } else {
    toast.warning("Please select both From and To dates");
  }
};

// ✅ Cancel Custom Date Range
const handleCancelCustomDateRange = () => {
  setTempCustomDateRange({ from: "", to: "" });
  setShowCustomDateInputs(false);
};
  // ===== Initial Data Fetch =====
  useEffect(() => {
    fetchAllData();
  }, []);
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchVouchers(1, true, filters);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, dateRangeFilter, customDateRange]);

  const fetchVouchers = async (
    pageNum = 1,
    reset = false,
    filterValues = filters
  ) => {
    // ⭐ Date range add karo filters mein
    const apiFilters = {
      ...filterValues,
      date_range: dateRangeFilter,
      from_date: customDateRange.from,
      to_date: customDateRange.to,
    };

    // ⭐ apiFilters pass karo, filterValues nahi
    const data = await GetPurchaseVoucherList(apiFilters, pageNum);

    if (reset || pageNum === 1) {
      setPurchaseVouchers(
        Array.isArray(data) ? data.results : data.results || []
      );
    } else {
      setPurchaseVouchers((prev) => [
        ...prev,
        ...(Array.isArray(data) ? data.results : data.results || []),
      ]);
    }

    setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
    setPage(pageNum);
  };

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchVouchers(nextPage);
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
  const fetchAllData = async () => {
    try {
      const [transporter, purchase] = await Promise.all([
        getAllTransporter(),
        fetchpos(),
      ]);

      setTransporterLists(
        Array.isArray(transporter) ? transporter : transporter?.results || []
      );
      setPurchaseLists(
        Array.isArray(purchase) ? purchase : purchase?.results || []
      );
    } catch (error) {
      toast.error("Error fetching initial data");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  // ===== Form Utilities =====
  function blankRow() {
    return {
      purchase_voucher_no: "",
      purchase_number: "",
      project: "",
      indent: "",
      purchase: "",
      division: "",
      transporter_name: "",
      invoice_number: "",
      lr_no: "",
      vehicle_no: "",
      amount: "",
      attachment: "",
      payment_status: "",
      supplier: "",
      invoice_date: "",
      narration: "",
    };
  }

  const handleRowChange = (index, e) => {
    const { name, value, files } = e.target;
    const updated = [...rows];
    updated[index][name] = name === "attachment" ? files[0] : value;
    setRows(updated);
  };

  const addRow = () => setRows([...rows, blankRow()]);
  const removeRow = (index) => setRows(rows.filter((_, i) => i !== index));

  // ===== Modal Handlers =====
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setRows([blankRow()]);
    setOpen(false);
  };
  const fetchNextPvNo = async () => {
    const data = await GetNextPvNo();
    if (data && data.purchase_voucher_no) {
      setRows((prev) => {
        const updated = [...prev];
        // sirf first row ka voucher no set karo
        if (updated.length > 0) {
          updated[0] = {
            ...updated[0],
            purchase_number: data.purchase_voucher_no,
          };
        }
        return updated;
      });
    }
  };

  const handleEditClick = async (id) => {
    const data = await GetPurchaseVoucherById(id);
    if (data) {
      setEditFormData(data);
      setEditModalOpen(true);
    }
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (voucher) => {
    setViewData(voucher);
    setViewModalOpen(true);
  };
  const userId = Number(localStorage.getItem("user_id"));

  // ===== Submit Handlers =====
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // 🔹 start loader

    const timestamp = Date.now();
    const newData = rows.map((row, i) => ({
      ...row,
      created_by: userId,
      id: timestamp + i,
    }));

    for (const row of newData) {
      try {
        if (!validateForm(row)) return;

        const formData = new FormData();
        formData.append("purchase_voucher_no", row.purchase_voucher_no || "");
        formData.append("purchase_number", row.purchase_number || "");
        formData.append("project", row.project || "");
        formData.append("division", row.division || "");
        formData.append("indent", row.indent || "");
        formData.append("supplier", row.supplier || "");
        formData.append("invoice_date", row.invoice_date || "");
        formData.append("invoice_number", row.invoice_number || "");
        formData.append("purchase", row.purchase || "");
        formData.append("transporter_name", row.transporter_name || "");
        formData.append("lr_no", row.lr_no || "");
        formData.append("vehicle_no", row.vehicle_no || "");
        formData.append("amount", row.amount || "");
        formData.append("payment_status", row.payment_status || "");
        formData.append("narration", row.narration || "");
        formData.append("created_by", row.created_by);
        if (row.attachment instanceof File) {
          formData.append("attachment", row.attachment);
        }

        await CreatePurchaseVoucher(formData);
      } catch (error) {
      }
    }

    setLoading(false); // 🔹 stop loader

    const updatedList = await GetPurchaseVoucherList(); // 🔄 Refresh table
    setPurchaseVouchers(updatedList.results || []);
    toast.success("Voucher(s) added successfully");
    handleClose();
  };

  const handleEditSave = async () => {
    try {
      if (!validateForm(editFormData)) {
        toast.error("Please fill all required fields.");
        return;
      }
      const formData = new FormData();
      formData.append("purchase_voucher_no", editFormData.purchase_voucher_no);
      formData.append("purchase_number", editFormData.purchase_number);
      formData.append("project", editFormData.project);
      formData.append("division", editFormData.division);
      formData.append("indent", editFormData.indent);
      formData.append("supplier", editFormData.supplier);
      formData.append("purchase", editFormData.purchase);
      formData.append("invoice_date", editFormData.invoice_date);
      formData.append("invoice_number", editFormData.invoice_number);
      formData.append("transporter_name", editFormData.transporter_name);
      formData.append("lr_no", editFormData.lr_no);
      formData.append("vehicle_no", editFormData.vehicle_no);
      formData.append("amount", editFormData.amount);
      formData.append("narration", editFormData.narration);
      formData.append("payment_status", editFormData.payment_status);
      // 🔑 File sirf tabhi append karo jab vo File ho
      if (editFormData.attachment instanceof File) {
        formData.append("attachment", editFormData.attachment);
      }

      const response = await UpdatePurchaseVoucher(
        editFormData.purchase_voucher_no,
        formData // ab JSON nahi, FormData ja raha hai
      );

      setPurchaseVouchers(response);
      setEditModalOpen(false);
      toast.success("Updated successfully!");
    } catch (error) {
      toast.error("Update failed.");
    }
  };

  const handleDelete = async (voucherId) => {
    try {
      await DeletePurchaseVoucher(voucherId); // DELETE API
      const updatedList = await GetPurchaseVoucherList(); // GET latest
      setPurchaseVouchers(updatedList); // Update table
      toast.success("Deleted successfully!");
    } catch (error) {
      toast.error("Delete failed.");
    }
  };

  //===================search=============================

  const handleApprove = async (voucher) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApprovePurchaseVoucher(
        voucher.purchase_voucher_no, // <-- important change
        approvedById,
        voucher.status,
        remarkInput
      );

      setPurchaseVouchers((prev) =>
        prev.map((item) =>
          item.purchase_voucher_no === updated.purchase_voucher_no
            ? updated
            : item
        )
      );

      toast.success("Purchase Voucher approved successfully!");
    } catch (error) {
      toast.error("Failed to approve Purchase Voucher.");
    }
  };
  const userRole = localStorage.getItem("role"); // "admin" ya "staff"
  const validateForm = (data) => {
    const errors = {};
    const rowErrs = [];

    if (!data.indent) errors.indent = "Required";
    if (!data.supplier) errors.supplier = "Required";
    if (!data.purchase) errors.purchase = "Required";
    if (!data.transporter_name) errors.transporter_name = "Required";
    if (!data.lr_no) errors.lr_no = "Required";
    if (!data.vehicle_no) errors.vehicle_no = "Required";
    if (!data.amount) errors.amount = "Required";
    if (!data.payment_status) errors.payment_status = "Required";

    setFormErrors(errors);
    setRowErrors(rowErrs);

    return (
      Object.keys(errors).length === 0 &&
      rowErrs.every((e) => Object.keys(e).length === 0)
    );
  };

  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  // ⭐ DATE RANGE HELPER FUNCTIONS
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const fmt = (d) => `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1).toString().padStart(2, "0")}-${d.getFullYear()}`;

    switch (rangeType) {
      case "today": return fmt(now);
      case "yesterday":
        const y = new Date(now); y.setDate(y.getDate() - 1); return fmt(y);
      case "this_week":
        const ws = new Date(now); ws.setDate(ws.getDate() - ws.getDay() + 1);
        return `${fmt(ws)} to ${fmt(now)}`;
      case "previous_week":
        const pwe = new Date(now); pwe.setDate(pwe.getDate() - pwe.getDay());
        const pws = new Date(pwe); pws.setDate(pws.getDate() - 6);
        return `${fmt(pws)} to ${fmt(pwe)}`;
      case "this_month":
        return `${fmt(new Date(now.getFullYear(), now.getMonth(), 1))} to ${fmt(now)}`;
      default: return "";
    }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  return (
    <>
      <ToastContainer />

      {/* ✅ Responsive Filters */}
      <Box
        display="flex"
        flexWrap={{ xs: "wrap", md: "nowrap" }} // ✅ Mobile mein wrap, Desktop mein nowrap
        alignItems="center"
        sx={{
          mt: -3,
          pt: -3,
          mb: 2,
          width: "100%",
          gap: 2,
        }}
      >
        {/* Radio Buttons */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexShrink: 0,
            width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
            justifyContent: { xs: "space-around", md: "flex-start" }, // ✅ Mobile mein center
          }}
        >
          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Pending"
              checked={filters.status === "Pending"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Pending
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Approved"
              checked={filters.status === "Approved"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Approved
          </label>

          <label style={{ fontSize: "12px" }}>
            <input
              type="radio"
              name="status"
              value="Rejected"
              checked={filters.status === "Rejected"}
              onChange={handleFilterChange}
              style={{ marginRight: "5px", transform: "scale(0.9)" }}
            />
            Rejected
          </label>
        </Box>
        {/* ⭐ DATE RANGE FIELD - ADD THIS */}
        <Box sx={{ width: { xs: "100%", sm: "50%", md: "20%" } }}>
          <TextField
            label="Date Range"
            value={
              dateRangeFilter === "custom" && customDateRange.from && customDateRange.to
                ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                : dateRangeFilter === "today"
                  ? "Today"
                  : dateRangeFilter === "yesterday"
                    ? "Yesterday"
                    : dateRangeFilter === "this_week"
                      ? "This Week"
                      : dateRangeFilter === "previous_week"
                        ? "Previous Week"
                        : dateRangeFilter === "this_month"
                          ? "This Month"
                          : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: <IconButton size="small"><ArrowDropDownIcon /></IconButton>,
            }}
            sx={{
              cursor: "pointer",
              "& .MuiInputBase-input": { fontSize: "0.8rem", padding: "4px 8px" },
              "& .MuiInputBase-root": { height: 30, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.7rem" },
            }}
          />
        </Box>

        {/* Search Boxes */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flex: 1,
            width: "100%",
            flexDirection: { xs: "column", md: "row" }, // ✅ Mobile mein column, Desktop mein row
          }}
        >
          <TextField
            label="Purchase Voucher No"
            name="purchase_no"
            size="small"
            value={filters.purchase_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" }, // ✅ Desktop mein flex
              width: { xs: "100%", md: "auto" }, // ✅ Mobile mein full width
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="PO No"
            name="po_no"
            size="small"
            value={filters.po_no}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
          <TextField
            label="Supplier"
            name="supplier"
            size="small"
            value={filters.supplier}
            onChange={handleFilterChange}
            sx={{
              flex: { xs: "none", md: "1 1 150px" },
              width: { xs: "100%", md: "auto" },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.65rem",
              },
            }}
          />
        </Box>

        <input
          ref={dateInputRef}
          type="date"
          style={{ position: "absolute", opacity: 0, pointerEvents: "none", width: 1, height: 1 }}
          value={selectingDate === "from" ? customDateRange.from : customDateRange.to}
          min={selectingDate === "to" ? customDateRange.from : undefined}
          onChange={(e) => {
            const val = e.target.value;
            if (selectingDate === "from") {
              setCustomDateRange((p) => ({ ...p, from: val }));
              setSelectingDate("to");
              setTimeout(() => dateInputRef.current?.showPicker(), 100);
            } else {
              setCustomDateRange((p) => ({ ...p, to: val }));
              setDateRangeFilter("custom");
              setSelectingDate(null);
              setDateMenuAnchor(null);
            }
          }}
        />

        {/* ⭐ DATE MENU - ADD THIS */}
       {/* ✅ Date Range Menu with Inline Custom Section */}
<Menu
  anchorEl={dateMenuAnchor}
  open={Boolean(dateMenuAnchor)}
  onClose={() => {
    setDateMenuAnchor(null);
    setShowCustomDateInputs(false);
    setTempCustomDateRange({ from: "", to: "" });
  }}
  PaperProps={{ sx: { width: 340, maxHeight: 480 } }}
>
  {[
    { key: "today", label: "Today" },
    { key: "yesterday", label: "Yesterday" },
    { key: "this_week", label: "This Week" },
    { key: "this_month", label: "This Month" },
  ].map((opt) => (
    <MenuItem
      key={opt.key}
      onClick={() => {
        setDateRangeFilter(opt.key);
        setCustomDateRange({ from: "", to: "" });
        setDateMenuAnchor(null);
        setShowCustomDateInputs(false);
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Typography variant="body2">{opt.label}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
          {getDateRangeDisplay(opt.key)}
        </Typography>
      </Box>
    </MenuItem>
  ))}

  <Divider />

  {/* Custom Range Collapsible */}
  <MenuItem
    onClick={() => setShowCustomDateInputs((s) => !s)}
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}>
      Custom Date Range
    </Typography>
    {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
  </MenuItem>

  <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
    <Box
      sx={{ px: 2, py: 2, bgcolor: "#f5f5f5", borderTop: "1px solid #e0e0e0" }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 1, display: "block" }}
      >
        Select Date Range
      </Typography>

      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        <TextField
          label="From Date"
          type="date"
          size="small"
          value={tempCustomDateRange.from}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, from: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: tempCustomDateRange.to || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
        <TextField
          label="To Date"
          type="date"
          size="small"
          value={tempCustomDateRange.to}
          onChange={(e) =>
            setTempCustomDateRange((p) => ({ ...p, to: e.target.value }))
          }
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: tempCustomDateRange.from || undefined }}
          sx={{
            flex: 1,
            "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
            "& .MuiInputLabel-root": { fontSize: "0.75rem" },
          }}
        />
      </Box>

      {tempCustomDateRange.from && tempCustomDateRange.to && (
        <Typography
          variant="caption"
          sx={{
            display: "block",
            mb: 1.5,
            p: 1,
            bgcolor: "#e8f5e9",
            borderRadius: 1,
            textAlign: "center",
            color: "#2e7d32",
            fontWeight: 500,
          }}
        >
          📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
          {formatDateDisplay(tempCustomDateRange.to)}
        </Typography>
      )}

      <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleCancelCustomDateRange}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleApplyCustomDateRange}
          disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
          sx={{ fontSize: "0.7rem", textTransform: "none", borderRadius: 1 }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  </Collapse>
</Menu>

      </Box>


      {/* ✅ Add Modal (Same as original) */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1400px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {rows.map((row, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  backgroundColor: "#f5f7fa",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  p: 2,
                }}
              >
                <Grid container spacing={2}>
                  {/* Your original Grid items - keeping all as is */}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Voucher No."
                      name="purchase_number"
                      value={row.purchase_number || ""}
                      size="small"
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Invoice No."
                      name="invoice_number"
                      value={row.invoice_number || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      error={!!formErrors.invoice_number}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Invoice Date"
                      name="invoice_date"
                      type="date"
                      value={row.invoice_date || ""}
                      onChange={(e) => handleRowChange(index, e)}
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.invoice_date}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={purchaseLists}
                      getOptionLabel={(option) =>
                        option && option.id ? `${option.po_number}` : ""
                      }
                      value={
                        purchaseLists.find((p) => p.id === row.purchase) || null
                      }
                      onChange={(e, newValue) => {
                        handleRowChange(index, {
                          target: {
                            name: "purchase",
                            value: newValue ? newValue.id : "",
                          },
                        });

                        if (newValue) {
                          handleRowChange(index, {
                            target: { name: "project", value: newValue.project || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "indent", value: newValue.indent || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "division", value: newValue.division || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "supplier", value: newValue.supplier || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "project_name", value: newValue.project_name || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "indent_no", value: newValue.indent_no || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "division_name", value: newValue.division_name || "" },
                          });
                          handleRowChange(index, {
                            target: { name: "supplier_name", value: newValue.supplier_name || "" },
                          });

                          const totalAmount =
                            newValue.items?.reduce(
                              (sum, i) => sum + Number(i.amount || 0),
                              0
                            ) || 0;

                          handleRowChange(index, {
                            target: { name: "amount", value: totalAmount.toFixed(2) },
                          });
                        } else {
                          [
                            "project", "indent", "division", "project_name",
                            "indent_no", "division_name", "amount", "supplier", "supplier_name",
                          ].forEach((field) =>
                            handleRowChange(index, { target: { name: field, value: "" } })
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Purchase Order"
                          size="small"
                          error={!!formErrors.purchase}
                          helperText={formErrors.purchase}
                        />
                      )}
                    />
                  </Grid>

                  {/* Remaining Grid items - same as original */}
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Project" name="project_name" size="small" value={row.project_name || ""} disabled />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Indent" name="indent_no" size="small" value={row.indent_no || ""} disabled />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Division" name="division_name" size="small" value={row.division_name || ""} disabled />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Supplier" name="supplier_name" size="small" value={row.supplier_name || ""} disabled />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Autocomplete
                      options={transporterLists}
                      getOptionLabel={(option) => option.transporter_name || ""}
                      value={transporterLists.find((d) => d.id === row.transporter_name) || null}
                      onChange={(e, newValue) =>
                        handleRowChange(index, {
                          target: { name: "transporter_name", value: newValue ? newValue.id : "" },
                        })
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Transporter Name" size="small" error={!!formErrors.transporter_name} helperText={formErrors.transporter_name} />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Amount" name="amount" value={row.amount || ""} size="small" error={!!formErrors.amount} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="LR No" name="lr_no" value={row.lr_no || ""} onChange={(e) => handleRowChange(index, e)} size="small" error={!!formErrors.lr_no} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Vehicle No" name="vehicle_no" value={row.vehicle_no || ""} onChange={(e) => handleRowChange(index, e)} size="small" error={!!formErrors.vehicle_no} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Payment Status" name="payment_status" value={row.payment_status || ""} onChange={(e) => handleRowChange(index, e)} select size="small" error={!!formErrors.payment_status}>
                      <MenuItem value="Paid">Paid</MenuItem>
                      <MenuItem value="Unpaid">Unpaid</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth label="Narration" name="narration" value={row.narration || ""} onChange={(e) => handleRowChange(index, e)} size="small" />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextField fullWidth type="file" name="attachment" id={`attachment-${index}`} onChange={(e) => handleRowChange(index, e)} label="Attachment" size="small" InputLabelProps={{ shrink: true }} error={!!formErrors.attachment} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    {rows.length > 1 && (
                      <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                        <Button variant="outlined" color="error" onClick={() => removeRow(index)} size="small" startIcon={<Close fontSize="small" />} sx={{ textTransform: "none", fontWeight: 500 }}>
                          Remove
                        </Button>
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>

          {/* Footer Buttons */}
          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button variant="outlined" onClick={handleSubmit} size="small" sx={{ px: 2, fontWeight: 500 }} disabled={loading}>
                {loading ? <CircularProgress size={22} color="inherit" /> : "Submit"}
              </Button>
              <Button variant="contained" onClick={handleClose} size="small" sx={{ px: 2 }}>
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ✅ Mobile/Desktop Conditional Rendering */}
      <InfiniteScroll
        dataLength={purchaseVouchers.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Collapsible Cards */
          <Box sx={{ bgcolor: "background.paper" }}>
            {purchaseVouchers.map((voucher, index) => (
              <Box key={index}>
                <Box
                  onClick={() =>
                    setExpandedPurchase(
                      expandedPurchase === voucher.purchase_voucher_no ? null : voucher.purchase_voucher_no
                    )
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": { bgcolor: "#e3f2fd" },
                    borderLeft: `4px solid ${voucher.status === "Approved" ? "#4caf50" : voucher.status === "Rejected" ? "#f44336" : "#ff9800"
                      }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                      <Typography sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}>#{index + 1}</Typography>
                      <Typography sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1 }}>{voucher.purchase_number}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: "0.75rem", color: "#666", display: "flex", alignItems: "center", gap: 1 }}>
                      <span style={{ fontWeight: 500 }}>{voucher.purchase_order || "N/A"}</span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>{formatDate(voucher.created_at)}</span>
                    </Typography>
                  </Box>
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedPurchase === voucher.purchase_voucher_no ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                  </IconButton>
                </Box>

                <Collapse in={expandedPurchase === voucher.purchase_voucher_no} timeout="auto" unmountOnExit>
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${voucher.status === "Approved" ? "#4caf50" : voucher.status === "Rejected" ? "#f44336" : "#ff9800"
                        }`,
                    }}
                  >
                    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0.8, mb: 1 }}>
                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>TOTAL AMOUNT</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#1976d2" }}>
                          ₹ {Number(voucher.total_amount || 0).toLocaleString("en-IN")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>PAID AMOUNT</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#4caf50" }}>
                          ₹ {Number(voucher.receipt_amount || 0).toLocaleString("en-IN")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>BALANCE AMOUNT</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#f44336" }}>
                          ₹ {Number(voucher.balance_amount || 0).toLocaleString("en-IN")}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px", mb: 0.3 }}>STATUS</Typography>
                        <Chip
                          label={voucher.status === "Approved" ? "Approved" : voucher.status === "Rejected" ? "Rejected" : "Pending"}
                          color={voucher.status === "Approved" ? "success" : voucher.status === "Rejected" ? "error" : "warning"}
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>PROJECT</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.project_name || "-"}</Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>INDENT</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.indent_no || "-"}</Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>DIVISION</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.division_name || "-"}</Typography>
                      </Box>

                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>TRANSPORTER</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.transporter || "-"}</Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>LR NO</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.lr_no || "-"}</Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>VEHICLE NO</Typography>
                        <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.vehicle_no || "-"}</Typography>
                      </Box>

                      <Box>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px", mb: 0.3 }}>PAYMENT STATUS</Typography>
                        <Chip
                          label={voucher.payment_status === "Paid" ? "Paid" : voucher.payment_status === "Unpaid" ? "Unpaid" : "Partial"}
                          color={voucher.payment_status === "Paid" ? "success" : voucher.payment_status === "Unpaid" ? "error" : "warning"}
                          variant="outlined"
                          size="small"
                          sx={{
                            // fontSize: "0.2rem", // 👈 font chhota hoga
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </Box>

                      {voucher.created_by_name && (
                        <Box>
                          <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>CREATED BY</Typography>
                          <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.created_by_name}</Typography>
                        </Box>
                      )}

                      {voucher.approved_name && (
                        <Box>
                          <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>APPROVED BY</Typography>
                          <Typography sx={{ fontSize: "0.72rem", fontWeight: 500, color: "#555" }}>{voucher.approved_name}</Typography>
                        </Box>
                      )}
                    </Box>

                    {voucher.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px", mb: 0.3 }}>REMARKS</Typography>
                        <Typography sx={{ fontSize: "0.7rem", color: "#555", fontStyle: "italic", lineHeight: 1.3 }}>{voucher.remarks}</Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor: voucher.status === "Approved" ? "#e8f5e9" : voucher.status === "Rejected" ? "#ffebee" : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${voucher.status === "Approved" ? "#4caf50" : voucher.status === "Rejected" ? "#f44336" : "#ff9800"
                              }`,
                          }}
                        >
                          <Checkbox
                            checked={voucher.status === "Approved" || voucher.status === "Rejected"}
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPurchaseToApprove(voucher);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color: voucher.status === "Approved" ? "#4caf50" : voucher.status === "Rejected" ? "#f44336" : "#ff9800",
                              "&.Mui-checked": { color: voucher.status === "Approved" ? "#4caf50" : "#f44336" },
                            }}
                          />
                          <Typography sx={{ fontSize: "0.7rem", fontWeight: 600, color: voucher.status === "Approved" ? "#2e7d32" : voucher.status === "Rejected" ? "#c62828" : "#f57c00" }}>
                            {voucher.status === "Approved" ? "Approved" : voucher.status === "Rejected" ? "Rejected" : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        {typeof voucher.attachment === "string" && (
                          <a href={`${voucher.attachment}`} target="_blank" rel="noopener noreferrer">
                            <IconButton size="small" sx={{ bgcolor: "#e1f5fe", borderRadius: "6px", width: 32, height: 32, "&:hover": { bgcolor: "#b3e5fc", transform: "scale(1.05)" }, transition: "all 0.2s" }}>
                              <Visibility sx={{ fontSize: "1rem", color: "#0288d1" }} />
                            </IconButton>
                          </a>
                        )}

                        {voucher.attachment instanceof File && (
                          <a href={URL.createObjectURL(voucher.attachment)} target="_blank" rel="noopener noreferrer">
                            <IconButton size="small" sx={{ bgcolor: "#e1f5fe", borderRadius: "6px", width: 32, height: 32, "&:hover": { bgcolor: "#b3e5fc", transform: "scale(1.05)" }, transition: "all 0.2s" }}>
                              <Visibility sx={{ fontSize: "1rem", color: "#0288d1" }} />
                            </IconButton>
                          </a>
                        )}

                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); generatePurchasePdf(voucher); }} sx={{ bgcolor: "#fff3e0", borderRadius: "6px", width: 32, height: 32, "&:hover": { bgcolor: "#ffe0b2", transform: "scale(1.05)" }, transition: "all 0.2s" }}>
                          <Print sx={{ fontSize: "1rem", color: "#f57c00" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>
                <Divider />
              </Box>
            ))}

            {/* ✅ MOBILE TOTAL SUMMARY */}
            {purchaseVouchers.length > 0 && (
              <Box sx={{ bgcolor: "#E3F2FD", p: 1.5, borderTop: "2px solid #1976d2", position: "sticky", bottom: 0, zIndex: 2 }}>
                <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", mb: 0.5, color: "#1976d2" }}>TOTAL SUMMARY</Typography>
                <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1 }}>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Total Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#1976d2" }}>
                      ₹ {purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.total_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Paid Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#4caf50" }}>
                      ₹ {purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.receipt_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: "0.6rem", color: "#666" }}>Bal Amt</Typography>
                    <Typography sx={{ fontSize: "0.75rem", fontWeight: "bold", color: "#f44336" }}>
                      ₹ {purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.balance_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Your Original Table */
          <TableContainer component={Paper} sx={{ maxHeight: "88vh", overflow: "auto" }}>
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1600,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                      fontSize: "0.75rem",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell sx={{ position: "sticky", left: 0, backgroundColor: "#fafafa", zIndex: 3 }}>Approve</TableCell>
                  )}
                  <TableCell sx={{ position: "sticky", left: userRole != "Staff" ? 80 : 0, backgroundColor: "#f5f5f5", zIndex: 3 }}>S.No.</TableCell>
                  <TableCell>Voucher No</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Total Amt</TableCell>
                  <TableCell>Paid Amt</TableCell>
                  <TableCell>Bal Amt</TableCell>
                  <TableCell>Project</TableCell>
                  <TableCell>Indent</TableCell>
                  <TableCell>Purchase Order</TableCell>
                  <TableCell>Division</TableCell>
                  <TableCell>Transporter Name</TableCell>
                  <TableCell>LR No</TableCell>
                  <TableCell>Vehicle No</TableCell>
                  <TableCell>Payment Status</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Created By</TableCell>
                  <TableCell>Approved By</TableCell>
                  <TableCell>Remarks</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", right: 0, backgroundColor: "#f5f5f5", zIndex: 3 }}>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {purchaseVouchers.map((voucher, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": { backgroundColor: "#e3f2fd", "& td": { backgroundColor: "#e3f2fd !important" } },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) => (theme.palette.mode === "dark" ? "white" : "inherit"),
                        backgroundColor: (theme) => (theme.palette.mode === "dark" ? "black" : "inherit"),
                      },
                    }}
                  >
                    {userRole != "Staff" && (
                      <TableCell sx={{ position: "sticky", left: 0, backgroundColor: "#fafafa", zIndex: 3 }}>
                        <Checkbox
                          checked={voucher.status === "Approved" || voucher.status === "Rejected"}
                          onChange={(e) => { setApproveAnchorEl(e.currentTarget); setPurchaseToApprove(voucher); }}
                          sx={{
                            padding: 0,
                            paddingLeft: 1,
                            paddingRight: 1,
                            transform: "scale(0.6)",
                            color: voucher.status === "Approved" ? "green" : voucher.status === "Rejected" ? "red" : "grey",
                            "&.Mui-checked": { color: voucher.status === "Approved" ? "green" : "red" },
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell sx={{ position: "sticky", left: userRole != "Staff" ? 80 : 0, backgroundColor: "#f5f5f5", zIndex: 3 }}>{index + 1}</TableCell>
                    <TableCell>{voucher.purchase_number}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={voucher.status === "Approved" ? "Approved" : voucher.status === "Rejected" ? "Rejected" : "Pending"}
                        color={voucher.status === "Approved" ? "success" : voucher.status === "Rejected" ? "error" : "warning"}
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{Number(voucher.total_amount || 0).toLocaleString("en-IN")}</TableCell>
                    <TableCell>{Number(voucher.receipt_amount || 0).toLocaleString("en-IN")}</TableCell>
                    <TableCell>{Number(voucher.balance_amount || 0).toLocaleString("en-IN")}</TableCell>
                    <TableCell>{voucher.project_name}</TableCell>
                    <TableCell>{voucher.indent_no}</TableCell>
                    <TableCell>{voucher.purchase_order}</TableCell>
                    <TableCell>{voucher.division_name}</TableCell>
                    <TableCell>{voucher.transporter}</TableCell>
                    <TableCell>{voucher.lr_no}</TableCell>
                    <TableCell>{voucher.vehicle_no}</TableCell>
                    <TableCell>
                      <Chip
                        label={voucher.payment_status === "Paid" ? "Paid" : voucher.payment_status === "Unpaid" ? "Unpaid" : "Partial"}
                        color={voucher.payment_status === "Paid" ? "success" : voucher.payment_status === "Unpaid" ? "error" : "warning"}
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>
                    <TableCell>{formatDate(voucher.created_at)}</TableCell>
                    <TableCell>{voucher.created_by_name}</TableCell>
                    <TableCell>{voucher.approved_name}</TableCell>
                    <TableCell>
                      <Tooltip title={voucher.remarks || ""} arrow>
                        <span>{truncateText(voucher.remarks || "", 20)}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ position: "sticky", right: 0, backgroundColor: "#f5f5f5", zIndex: 3, minWidth: 180 }}>
                      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 0.5 }}>
                        <IconButton sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }} color="warning" size="small" onClick={() => generatePurchasePdf(voucher)}>
                          <Print transform="scale(0.6)" />
                        </IconButton>
                        <span style={{ display: "inline-block", width: 36, textAlign: "center" }}>
                          {typeof voucher.attachment === "string" ? (
                            <a href={`${voucher.attachment}`} target="_blank" rel="noopener noreferrer">
                              <IconButton sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }} color="info" size="small">
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : voucher.attachment instanceof File ? (
                            <a href={URL.createObjectURL(voucher.attachment)} target="_blank" rel="noopener noreferrer">
                              <IconButton sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }} color="info" size="small">
                                <Visibility fontSize="small" />
                              </IconButton>
                            </a>
                          ) : (
                            <span style={{ display: "inline-block", width: 24 }} />
                          )}
                        </span>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

                {/* ✅ DESKTOP TOTAL ROW */}
                <TableRow sx={{ "& td": { backgroundColor: "#E3F2FD !important", color: "#000 !important", fontWeight: "bold !important" } }}>
                  <TableCell colSpan={userRole != "Staff" ? 5 : 4} align="right">Totals:</TableCell>
                  <TableCell>{purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.total_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell>{purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.receipt_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell>{purchaseVouchers.reduce((sum, v) => sum + parseFloat(v.balance_amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                  <TableCell colSpan={13}></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Your original Popovers - keeping as is */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(null); setVoucherToDelete(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button color="error" size="small" onClick={async () => { await handleDelete(voucherToDelete); setAnchorEl(null); setVoucherToDelete(null); }}>Yes</Button>
            <Button size="small" onClick={() => { setAnchorEl(null); setVoucherToDelete(null); }}>No</Button>
          </Box>
        </Box>
      </Popover>

      {/* Your original approve popover - keeping as is */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => { setApproveAnchorEl(null); setPurchaseToApprove(null); setRemarkInput(""); setShowRemarkForIndentId(null); setActionType(null); }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForIndentId === PurchaseToApprove?.purchase_voucher_no ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>Please enter remark before {actionType === "Approved" ? "approving" : "rejecting"}:</Typography>
              <TextField fullWidth size="small" value={remarkInput} onChange={(e) => setRemarkInput(e.target.value)} placeholder="Enter remark" />
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) { toast.error("Remark is required!"); return; }
                    handleApprove({ ...PurchaseToApprove, status: actionType, remarks: remarkInput });
                    setApproveAnchorEl(null); setPurchaseToApprove(null); setRemarkInput(""); setShowRemarkForIndentId(null); setActionType(null);
                  }}
                >Yes</Button>
                <Button size="small" onClick={() => { setApproveAnchorEl(null); setPurchaseToApprove(null); setRemarkInput(""); setShowRemarkForIndentId(null); setActionType(null); }}>No</Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>Do you want to approve or reject this Purchase Voucher?</Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                <Button color="success" size="small" onClick={() => { setShowRemarkForIndentId(PurchaseToApprove?.purchase_voucher_no); setActionType("Approved"); }}>Approve</Button>
                <Button color="error" size="small" onClick={() => { setShowRemarkForIndentId(PurchaseToApprove?.purchase_voucher_no); setActionType("Rejected"); }}>Reject</Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>


      {/* =========================EditModal========================== */}

      <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "1400px",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: "1px solid #ddd" }}>
            <Typography variant="h6" component="h2">
              Edit Daily Payment
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Purchase Voucher No"
                  name="purchase_number"
                  type="number"
                  value={editFormData.purchase_number || ""}
                  disabled
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Invoice No"
                  name="invoice_number"
                  value={editFormData.invoice_number || ""}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Date"
                  name="invoice_date"
                  type="date"
                  value={editFormData.invoice_date || ""}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  options={Array.isArray(purchaseLists) ? purchaseLists : []}
                  getOptionLabel={(option) =>
                    option && option.id ? ` ${option.purchase_number}` : ""
                  }
                  value={
                    (Array.isArray(purchaseLists) &&
                      purchaseLists.find(
                        (p) =>
                          p.id ===
                          (editFormData.puchase?.id || editFormData.purchase)
                      )) ||
                    null
                  }
                  onChange={(e, newValue) =>
                    setEditFormData((prev) => ({
                      ...prev,
                      purchase: newValue ? newValue.id : "",
                      project: newValue?.project || "",
                      indent: newValue?.indent || "",
                      division: newValue?.division || "",
                      supplier: newValue?.supplier || "",
                      indent_no: newValue?.indent_no || "",
                      project_name: newValue?.project_name || "",
                      supplier_name: newValue?.supplier_name || "",
                      division_name: newValue?.division_name || "",
                      amount:
                        newValue?.items
                          ?.reduce((sum, i) => sum + Number(i.amount || 0), 0)
                          .toFixed(2) || "0.00",
                    }))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Purchase Order"
                      size="small"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Indent"
                  name="indent_no"
                  value={editFormData.indent_no || ""}
                  size="small"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Project"
                  name="project_name"
                  value={editFormData.project_name || ""}
                  size="small"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Division"
                  name="division_name"
                  value={editFormData.division_name || ""}
                  size="small"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Supplier"
                  name="supplier_name"
                  value={editFormData.supplier_name || ""}
                  size="small"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  options={
                    Array.isArray(transporterLists) ? transporterLists : []
                  }
                  getOptionLabel={(option) => option.transporter_name || ""}
                  value={
                    transporterLists.find(
                      (t) =>
                        t.id ===
                        (editFormData.transporter_name?.id ||
                          editFormData.transporter_name)
                    ) || null
                  }
                  onChange={(e, newValue) =>
                    setEditFormData((prev) => ({
                      ...prev,
                      transporter_name: newValue ? newValue.id : null,
                      transporter_name_obj: newValue || null,
                    }))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Transporter Name"
                      size="small"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="LR No"
                  name="lr_no"
                  value={editFormData.lr_no || ""}
                  onChange={handleEditChange}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Vehicle No"
                  name="vehicle_no"
                  value={editFormData.vehicle_no || ""}
                  onChange={handleEditChange}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Amount"
                  name="amount"
                  type="number"
                  value={editFormData.amount || ""}
                  onChange={handleEditChange}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Payment Status"
                  name="payment_status"
                  value={editFormData.payment_status || ""}
                  onChange={handleEditChange}
                  select
                  size="small"
                >
                  <MenuItem value="Paid">Paid</MenuItem>
                  <MenuItem value="Unpaid">Unpaid</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Narration"
                  name="narration"
                  value={editFormData.narration || ""}
                  onChange={handleEditChange}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Box>
                  {typeof editFormData.attachment === "string" && (
                    <Box sx={{ mb: 1 }}>
                      <Typography variant="caption">
                        <a
                          href={`${editFormData.attachment}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none" }}
                        >
                          View Current Attachment
                        </a>
                      </Typography>
                    </Box>
                  )}
                  <TextField
                    fullWidth
                    type="file"
                    name="attachment"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setEditFormData((prev) => ({
                          ...prev,
                          attachment: file,
                        }));
                      }
                    }}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    label="Attachment"
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={3}></Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              borderTop: "1px solid #ddd",
              p: 2,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#fafafa",
              gap: 1,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={() => setEditModalOpen(false)}
              size="small"
              sx={{ px: 2 }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditSave}
              size="small"
              sx={{ px: 2 }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* =========================ViewModal========================== */}

      <Modal open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: "1000px",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: 24,
            p: 3,
            overflowY: "auto",
            maxHeight: "90vh",
          }}
        >
          <h2>View Purchase Voucher</h2>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {Object.entries(viewData).map(([key, value]) => (
              <TextField
                key={key}
                label={key.replace(/_/g, " ").toUpperCase()}
                value={value}
                fullWidth
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ flex: 1, minWidth: 180 }}
                margin="dense"
              />
            ))}
          </Box>

          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button
              onClick={() => setViewModalOpen(false)}
              color="primary"
              variant="contained"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PurchaseVouchers;
